<div class="m-0 p-0 h-100 w-100 pl-bgc d-flex overflow-auto" autoLogin>
    <div class="container h-100">
        <div class="row align-items-center h-100">
            <div class="col-10 mx-auto">
                <mat-card class="p-0 m-0 login-card pd-bgc" autoMargin>
                    <div class="row align-items-center card-row">
                        <div class="col-12 col-md-6 p-3">
                            <img src="assets/images/logos/logo.png" class="landing-logo">         
                            <!--
                            <h3 class="text-center font-weight-bold mb-4 s-tc" > developerd by </h3>             
                            <img src="assets/images/logos/splash-logo.png" class="landing-logo">   
                            -->                   
                        </div>
                        <div class="col-12  col-md-6 p-3 s-bgc">
                            <ng-container *ngIf="hub || orgDetail">

                                <h2 class="text-center font-weight-bold mt-4" translate>
                                    pages.landing.title
                                </h2>

                                <ng-container *ngIf="!hub">
                                    <mat-form-field floatLabel="always" *ngIf="orgDetail">
                                        <mat-label translate>
                                            pages.landing.fields.organization.label
                                        </mat-label>
                                        <input matInput [value]="orgDetail?.name" disabled>
                                    </mat-form-field>
                                </ng-container>

                                <mat-form-field floatLabel="always" *ngIf="hub">
                                    <mat-label translate>
                                        pages.landing.fields.hub.label
                                    </mat-label>
                                    <input matInput [value]="hub?.name" disabled>
                                </mat-form-field>

                                <!-- TODO: testo hardcoded, non ancora in i18n -->
                                <ng-container *ngIf="sso_tenant_id">
                                    <ng-container *ngIf="sso_session; else noSsoSession">
                                        <p class="text-center mt-4 mb-2 s-t l-tc">
                                            Sessione attiva: <strong>{{ sso_session.displayName || sso_session.username }}</strong>
                                        </p>
                                        <button type="button" mat-raised-button
                                                class="mt-2 rounded-lg login-button py-1 pl-bgc w-100"
                                                (click)="loginExternalWithSession()">
                                            <span class="font-weight-bold s-tc">Accedi</span>
                                        </button>
                                        <button type="button" mat-stroked-button
                                                class="mt-2 rounded-lg py-1 w-100"
                                                (click)="logoutExternalSession()">
                                            <span class="font-weight-bold">Logout</span>
                                        </button>
                                    </ng-container>
                                    <ng-template #noSsoSession>
                                        <p class="text-center mt-4 mb-2 s-t l-tc font-weight-light">
                                            Nessuna sessione esterna attiva
                                        </p>
                                        <button type="button" mat-raised-button
                                                class="mt-2 rounded-lg login-button py-1 pl-bgc w-100"
                                                (click)="loginExternal()">
                                            <span class="font-weight-bold s-tc">
                                                Accedi con provider esterno
                                            </span>
                                        </button>
                                    </ng-template>

                                    <div class="d-flex align-items-center my-3">
                                        <hr class="flex-grow-1 m-0">
                                        <span class="mx-2 s-t l-tc font-weight-light">oppure</span>
                                        <hr class="flex-grow-1 m-0">
                                    </div>
                                </ng-container>

                                <form class="h-100" [formGroup]="loginForm" (ngSubmit)="doLogin(0)">

                                    <mat-form-field floatLabel="always">
                                        <mat-label translate>
                                            pages.landing.fields.username.label
                                        </mat-label>
                                        <input matInput formControlName="username">
                                    </mat-form-field>
    
                                    <mat-form-field floatLabel="always" autocomplete="off" >
                                        <mat-label translate>
                                            pages.landing.fields.password.label
                                        </mat-label>                                    
                                        <input [type]="getPswType()" formControlName="password" matInput>
                                        <mat-icon class="align-middle cursor" matSuffix (click)="switchVisibility()">
                                            {{psw_visibility}}
                                        </mat-icon>
                                    </mat-form-field>
    
                                    <button type="submit" mat-raised-button class="mt-4 rounded-lg login-button py-1 pl-bgc">
                                        <span class="font-weight-bold s-tc" translate>
                                            pages.landing.button
                                        </span>
                                    </button>
    
                                    <p class="mt-3 s-t l-tc font-weight-light text-center" translate>
                                        pages.landing.copyright
                                    </p>
                                </form>    
                            </ng-container>
                            <ng-container *ngIf="!hub && !orgDetail" >
                                <h2 class="text-center font-weight-bold mt-4" translate>
                                    pages.landing.no_hub_org
                                </h2>

                                <form class="h-100 mt-4" [formGroup]="codeForm" (ngSubmit)="sendToUrl()">
                                    <mat-form-field floatLabel="always" autocomplete="off" >
                                        <mat-label translate>
                                            pages.landing.fields.code.label
                                        </mat-label>                                    
                                        <input type="text" matInput formControlName="code">
                                    </mat-form-field>
                                    <button type="submit" mat-raised-button class="mt-4 rounded-lg login-button py-1 pl-bgc">
                                        <span class="font-weight-bold s-tc" translate>
                                            pages.landing.code_button
                                        </span>
                                    </button>
                                </form>    
                            </ng-container>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>    
</div>